import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AppState } from '../state/app/app.state';

@Injectable()
export class IfIsAdminGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isRecruiter = this.store.selectSnapshot(AppState.userType) === 'RECRUITER';
    if (!isRecruiter) {
      this.router.navigateByUrl('/').then();
    }
    return isRecruiter;
  }
}
